import api from '..'
const requests = {
    submit: async ({
        errorCode,
        message,
        stackTrace,
        exceptionType,
        comments,
        url,
        route,
        method,
        data,
        binaryImage,
        appStackTrace
    }) => {
        var formData = new FormData()
        formData.append('Screenshot', binaryImage)
        formData.append('ErrorCode', errorCode)
        formData.append('Message', message)
        formData.append('StackTrace', stackTrace)
        formData.append('ExceptionType', exceptionType)
        formData.append('Comments', comments)
        formData.append('Url', url)
        formData.append('Route', route)
        formData.append('Method', method)
        formData.append('Data', data)
        formData.append('AppStackTrace', appStackTrace)

        var response = await api.post(`/crm/BugReport`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        return response.data
    }
}

export default requests
